import { makeRoute } from './makeRoute';

/**
 * Mirrors `fundWizardMode` in wizardUtils.ts. The wizard's parser drops an
 * unknown value, so a stale name here opens the wizard on its first step rather
 * than erroring.
 */
export type FundWizardMode = 'create' | 'migrate';

/**
 * The app's front door with the fund wizard already open.
 *
 * The two keys are declared in wizardUtils.ts and spelled out here rather than
 * imported, because this file has to stay clear of nuqs for routes/server to
 * carry it. Keep the names in step with that file.
 *
 * The argument is an object because makeRoute spreads whatever it is handed to
 * lift `hash` and `useFullUrl` off it. A bare string spread into its own
 * characters and reached the query as [object Object].
 */
export const fundWizard = makeRoute(
  ({ mode }: { mode: FundWizardMode }) =>
    `/?${new URLSearchParams({ isFundWizardOpen: 'true', fundWizardMode: mode }).toString()}`,
  'app',
);
